import { DocumentInterface, FilePermissionEnum } from '@/services/folders/types'
import { OrgAccount } from '@/types/org'
import { UsageRecord } from '@/types/user'

export const usage_record_modules = ['workspace', 'brand_voice', 'structure', 'action'] as const
export type UsageRecordModule = (typeof usage_record_modules)[number]

export const canUseModule = (usage_record: UsageRecord, module: UsageRecordModule) => {
    return usage_record[module].used < usage_record[module].allowed
}

export const hasEditAccess = (document: DocumentInterface, account?: OrgAccount) => {
    if ([FilePermissionEnum.OWNER, FilePermissionEnum.EDITOR].includes(document.file_permission)) {
        return true
    }

    if (!account) {
        return false
    }

    return (
        document.permissions?.some(
            permission =>
                permission.account === account?.id &&
                [FilePermissionEnum.OWNER, FilePermissionEnum.EDITOR].includes(permission.role as any)
        ) ||
        (document.shared_with_workspace?.enabled && document.shared_with_workspace?.role === 'editor')
    )
}

const hasOwnerAccess = (document: DocumentInterface) => {
    if ([FilePermissionEnum.OWNER].includes(document.file_permission)) {
        return true
    }
    return false
}
void hasOwnerAccess
